// extracted by mini-css-extract-plugin
export var actionButtons = "subscription-card-module--action-buttons--1d4c5";
export var actionDisclaimers = "subscription-card-module--action-disclaimers--ce72b";
export var button = "subscription-card-module--button--19533";
export var container = "subscription-card-module--container--28e3d";
export var item = "subscription-card-module--item--50b5b";
export var itemLabel = "subscription-card-module--item-label--66dba";
export var list = "subscription-card-module--list--994c8";
export var offer = "subscription-card-module--offer--10020";
export var offerButton = "subscription-card-module--offer-button--ecd4d";
export var offerContent = "subscription-card-module--offer-content--77e48";
export var offerDescription = "subscription-card-module--offer-description--5f910";
export var offerName = "subscription-card-module--offer-name--537ad";
export var title = "subscription-card-module--title--7ad59";